import React from "react";
import {
    DashIcon,
    MktgIcon,
    SettingsIcon,
    SupportIcon,
    WebsiteIcon,
    FansIcon,
    FansIconPath,
    DashboardIconPath,
    MarketingIconPath,
    WebsiteIconPath,
    SettingsIconPath,
    GiftIcon,
    GiftIconPath,
    SupportIconPath,
    LearnIcon,
    LearnIconPath,
    TeamIconPath,
    TeamIcon
} from "../svg-icons"
import MobileNavigation from "./MobileNavigation";
import DesktopNavigation from "./DesktopNavigation";
import Intercom from "helpers/Intercom";
import useBrand from 'Hooks/useBrand';
import useOrganization from 'Hooks/useOrganization';
import useScreen from "Hooks/useScreen";
import { useNavbar } from "Hooks/useNavbar";
import { useLocation } from "react-router-dom";

export const showIntercom = () => {
    // @ts-ignore
    Intercom.open();
}

export const showNewMessageIntercom = () => {
    // @ts-ignore
    Intercom.showNewMessage();
}

export interface NavigationItem {
    name: string;
    smallName?: string;
    iconComponent?: React.ComponentType<{ color?: string; height?: string; width?: string }>;
    onClick?: (e: any) => void;
    href?: string;
    alternateHrefs?: string[];
    iconPath?: React.ReactElement,
    svgIconViewbox?: string;
    dropdownItems?: NavigationItem[]
    showOnMobileMainMenu: boolean;
    showOnDesktopMainMenu: boolean;
    showOnMobileSubMenu: boolean;
    showOnDesktopSubMenu: boolean;
    icon?: string;
}

const Navbar = () => {
    const location = useLocation();
    const { mobileView } = useScreen();
    const { shouldHideNavbar } = useNavbar();
    const { currentBrand, isPaidBrand } = useBrand()
    const { organization } = useOrganization();
    const hasOrganization = (organization && organization.name) || (currentBrand?.isFromAdminSearch && currentBrand?.organizationName);

    let navigationItems: NavigationItem[] = [
        {
            name: "Marketing",
            href: "/",
            alternateHrefs: ["/marketing"],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <MktgIcon {...props} />,
            iconPath: <MarketingIconPath />,
            icon: "marketing",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: true,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Website",
            href: "/website",
            alternateHrefs: [],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <WebsiteIcon {...props} />,
            iconPath: <WebsiteIconPath />,
            icon: "website",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: true,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Dashboard",
            href: "/dashboard",
            alternateHrefs: [],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <DashIcon {...props} />,
            iconPath: <DashboardIconPath />,
            icon: "dashboard",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: true,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Fans",
            href: "/fans",
            alternateHrefs: [],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <FansIcon {...props} />,
            iconPath: <FansIconPath />,
            icon: "audiences",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: true,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Team",
            href: "/team",
            alternateHrefs: [],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <TeamIcon {...props} />,
            iconPath: <TeamIconPath />,
            icon: "home",
            svgIconViewbox: "0 0 20 18",
            showOnMobileMainMenu: false,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: true,
            showOnDesktopSubMenu: false
        },
        // TODO CONNER: put back when using V2!
        // {
        //     name: "Team 2",
        //     href: "/team2",
        //     alternateHrefs: [],
        //     iconComponent: (props: { color?: string, height?: string, width?: string }) => <TeamIcon {...props} />,
        //     iconPath: <TeamIconPath />,
        //     icon: "home",
        //     svgIconViewbox: "0 0 20 18",
        //     showOnMobileMainMenu: false,
        //     showOnDesktopMainMenu: true,
        //     showOnMobileSubMenu: true,
        //     showOnDesktopSubMenu: false
        // },
        {
            name: "Learn",
            href: "/learn",
            alternateHrefs: [],
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <LearnIcon {...props} />,
            iconPath: <LearnIconPath />,
            icon: "learn",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: false,
            showOnDesktopMainMenu: true,
            showOnMobileSubMenu: true,
            showOnDesktopSubMenu: true,
            dropdownItems: [
                {
                    name: "Videos",
                    href: "/learn",
                    alternateHrefs: [],
                    iconComponent: (props: { color?: string, height?: string, width?: string }) => <FansIcon {...props} />,
                    iconPath: <FansIconPath />,
                    icon: "videos",
                    svgIconViewbox: "0 0 18 18",
                    showOnMobileMainMenu: false,
                    showOnDesktopMainMenu: false,
                    showOnMobileSubMenu: true,
                    showOnDesktopSubMenu: true,
                },
                {
                    name: "Help Center",
                    alternateHrefs: [],
                    iconComponent: (props: { color?: string, height?: string, width?: string }) => <FansIcon {...props} />,
                    iconPath: <FansIconPath />,
                    icon: "help-center",
                    svgIconViewbox: "0 0 18 18",
                    onClick: (e: any) => {
                        e.preventDefault()
                        Intercom.showHelpCenter()
                    },
                    showOnMobileMainMenu: false,
                    showOnDesktopMainMenu: false,
                    showOnMobileSubMenu: true,
                    showOnDesktopSubMenu: true,
                },
                {
                    name: "Contact Support",
                    iconComponent: (props: { color?: string, height?: string, width?: string }) => <SupportIcon {...props} />,
                    iconPath: <SupportIconPath />,
                    icon: "contact-support",
                    onClick: (e: any) => {
                        e.preventDefault()
                        Intercom.showMessages()
                    },
                    svgIconViewbox: "0 0 18 18",
                    showOnMobileMainMenu: false,
                    showOnDesktopMainMenu: false,
                    showOnMobileSubMenu: false,
                    showOnDesktopSubMenu: isPaidBrand,
                },
            ]
        },

        // only shown on mobile - additional options
        {
            name: "Settings",
            href: '/settings',
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <SettingsIcon {...props} />,
            iconPath: <SettingsIconPath />,
            icon: "gear",
            svgIconViewbox: "0 0 22.54 22.59",
            showOnMobileMainMenu: false,
            showOnDesktopMainMenu: false,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Refer & Earn",
            smallName: "Refer",
            href: '/refer',
            alternateHrefs: [],
            iconComponent: (props: {}) => <GiftIcon {...props} />,
            iconPath: <GiftIconPath />,
            icon: "gift",
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: false,
            showOnDesktopMainMenu: false,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
        {
            name: "Contact Support",
            iconComponent: (props: { color?: string, height?: string, width?: string }) => <SupportIcon {...props} />,
            iconPath: <SupportIconPath />,
            icon: "support",
            onClick: (e: any) => {
                e.preventDefault()
                showIntercom()
            },
            svgIconViewbox: "0 0 18 18",
            showOnMobileMainMenu: false,
            showOnDesktopMainMenu: false,
            showOnMobileSubMenu: false,
            showOnDesktopSubMenu: false,
        },
    ]

    /** Remove Fans tab if specified in brand settings */
    if (currentBrand?.hideFansTab) {
        navigationItems = navigationItems.filter((navItem: NavigationItem) => navItem.name !== "Fans");
    }

    /** Update Team visibility based on organization status */
    // if (hasOrganization) {
    //     navigationItems = navigationItems.map(item =>
    //         item.name === "Team"
    //             ? { ...item, showOnDesktopMainMenu: true }
    //             : item
    //     );
    // }

    const hideNavbar = shouldHideNavbar(location.pathname, organization, currentBrand);

    if (hideNavbar) {
        return null;
    }

    if (mobileView) {
        return (
            <MobileNavigation
                navigationItems={navigationItems}
            />
        )
    }

    return (
        <DesktopNavigation
            navigationItems={navigationItems}
        />
    )
}

export default Navbar
